// TODO delete this function after adding export to same util in framework
function toFinancialFloat(value: number, decimalLimit = 2): number {
  const strValue = value.toString();
  const isExponential = strValue.includes('e');
  const number = isExponential ? value.toFixed(8) : strValue;

  const regex = new RegExp(`^-?\\d+\\.?\\d{0,${decimalLimit}}`);
  const match = regex.exec(number);

  if (match) {
    return !Object.is(parseFloat(match[0]), -0) ? parseFloat(match[0]) : 0;
  }

  return 0;
}

export interface ICurrenciesModel {
  platformId: number;
  platformName: string;
  code: string;
  precision: number;
}

export function toFormattedABCCurrency(
  value: number,
  currency: string,
  platformId: number,
  currencyDictionary: ICurrenciesModel[]
): string {
  if (!value && value !== 0) return '';

  const currentCurrencyData = currencyDictionary.find(
    (item) => item.platformId === platformId && item.code === currency
  );

  const formattedValue = toFinancialFloat(
    value,
    currentCurrencyData?.precision
  );
  const optionsIntl = {
    minimumFractionDigits: 2,
    maximumFractionDigits: currentCurrencyData?.precision,
  };

  return new Intl.NumberFormat('en-EN', optionsIntl).format(formattedValue);
}
